module.exports = __webpack_public_path__ + "static/img/STANDARD.24c7f715.jpg";